const transactionsInitialState = {
  inboundTransactions: null,
  outboundTransactions: null,
  shouldFetchTransactions: true
};

export default transactionsInitialState;
